module.exports = __webpack_public_path__ + "static/media/tutorial-banner.9ec0ed3a.png";